// extracted by mini-css-extract-plugin
export default {"mobile":"mobile","about":"z_bMQ6sD","aboutProject":"zjS8yrrM","ads":"WtsKQSXx"};